export const QA_NAME_TABLE_CELL_TEXT = 'cell'
